// extracted by mini-css-extract-plugin
module.exports = {"Sub":"Sub--3EGxO","Text":"Text--29Q24"};